import React, { FC } from 'react';
import clsx from 'clsx';
import * as Styled from './AIcon.styles';
import { AIconProps, AIconSize } from './AIcon.types';

const COMPONENT_NAME = 'a-web-ui-kit-AIcon';
const TEST_ID = 'web-ui-kit-AIcon';

const sizeMapping: Record<AIconSize, number> = {
  [AIconSize.S]: 16,
  [AIconSize.M]: 20,
  [AIconSize.L]: 24,
  [AIconSize.XL]: 32,
  [AIconSize.XXL]: 40,
  [AIconSize.XXXL]: 64,
};

export const AIcon: FC<AIconProps> = ({ size = AIconSize.S, icon, className, ...rest }) => {
  const pxSize = sizeMapping[size] ?? sizeMapping[AIconSize.S];
  const hiddenOrAccessibleProps = {
    ...(rest['aria-label']
      ? {
          'aria-atomic': true,
          role: rest['aria-live'] ? 'status' : 'img',
        }
      : {
          // decorative (no aria-label)
          role: rest['aria-live'] ? 'status' : 'presentation',
        }),
  };

  return icon ? (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} $size={pxSize}>
      <span className={clsx(`icon`, icon, className)} {...hiddenOrAccessibleProps} {...rest} />
    </Styled.Wrapper>
  ) : null;
};

export { AIconSize, TEST_ID as A_ICON_TEST_ID };
